




















































import Vue from 'vue';
import { SchemaModel, ValueType } from '@/types';
import { mapActions } from 'vuex';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import { ValidationModel } from '@/types/models/validation';

export default Vue.extend({
  name: 'ExampleCustomBuiltInListItem',
  mixins: [],
  props: {
    schemas: {
      type: Array as () => SchemaModel[],
      required: true
    }
  },
  data() {
    return {
      valueType: ValueType,
      selectEmails: [{ email: 'John.Doe@email.com' }, { email: 'Joe.Bloggs@email.com' }, { email: 'Jane.Doe@email.com' }, { email: 'Validation Error' }] as any[]
    };
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    onDirtyDynamicForm(this: any, dirty: boolean) {
      if (dirty) {
        this.setApplicationDirty(true);
      }
    },
    onSchemaChanged(this: any) {
      this.$emit('update:schema', this.schema);
    }
  },
  computed: {
    schema: {
      get(this: any) {
        return this.schemas;
      },
      async set(this: any, value: SchemaModel[]) {
        this.$emit('update:schema', value);
      }
    }
  },
  created(this: any) {
    this.mobileNumberValidation = {
      required: true,
      valueType: ValueType.MobileNumber,
      maxLength: 15
    } as ValidationModel;
    this.nameValidation = {
      required: true,
      valueType: ValueType.AlphaNumeric,
      maxLength: 100
    } as ValidationModel;
    this.emailValidation = {
      required: true,
      valueType: ValueType.Email,
      maxLength: 100
    } as ValidationModel;
  },
  components: { MStoreFormSelect }
});
